<!-- v1.5 - in use -->
<template>
  <div>
    <div class="loading loading--pdp" v-if="loading">
      <!-- <loadingAnimation /> -->
      <div class="pdp-loading-title"><span></span></div>
      <div class="pdp-loading-images">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="pdp-loading-text"><span></span></div>
    </div>
    <!-- <div v-else-if="error">
      <pdpError error="true" />
    </div> -->
    <div v-else>
      <div id="pdpStandard">
      <div v-if="isMobile" class="mobile-title-details d-md-none">
        <div v-if="!isDonationOrGiftCard" class="row">
          <div class="col">
            <!-- ==================== MINI YOTPO STARS ==================== -->
            <div
              @click="scrollToReviews()"
              class="reviews"
              v-if="numReviews > 0"
            >
              <ReviewStars :numStars="avgReview" :numReviews="numReviews" />
            </div>
            <!-- .reviews -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->

        <div class="row">
          <!-- .col -->
          <div class="col">
            <h5>{{ product.title }}</h5>
          </div>
          <row class="title">
            <div class="col">
              <div v-if="!outOfStock">
                <div v-if="selectedColor.compareAtPrice > selectedVariantPrice">
                  <h6 class="price mb-0">
                    <span class="compare-price">{{
                      formatPrice(selectedColor.compareAtPrice)
                    }}</span>
                    <span class="sale-price">{{
                      formatPrice(selectedVariantPrice)
                    }}</span>
                  </h6>
                  <span class="savings">
                    You save ${{
                      priceSavings(
                        selectedVariantPrice,
                        selectedColor.compareAtPrice
                      )
                    }}
                  </span>
                </div>
                <div v-else>
                  <h6 class="price">
                    {{ formatPrice(selectedVariantPrice) }}
                  </h6>
                </div>
              </div>
            </div>
            <!-- .col -->
          </row>
        </div>
      </div>
      <div class="ctpx-pdp-images ctpx-pdp-images-a" id="pdpImagesA">
        <div
          class="row"
          v-if="
            !isMobile && outOfStock && product.colorwayGroups.currentColorways
          "
        >
          <!-- ============ if outofstock show the 1st color images ============ -->
          <div
            class="col-sm-6 img-slide"
            v-for="(img, index) in product.colorwayGroups.currentColorways[0]
              .images"
            :id="'img1' + index"
            :key="img.large"
          >
            <img
              :src="img.large"
              :alt="img.alt"
              itemprop="image"
              class="img-fluid"
            />
            <span class="zoom" @click="openModal(index)">+</span>
            <span class="small-print">{{ getModelInfo(img.alt) }}</span>
          </div>
          <!-- .col-sm-6 -->
          <!-- =========== show product level images =========== -->
          <div
            class="col-sm-6 img-slide"
            v-for="(img, index) in productImages"
            :id="'img2' + index"
            :key="img.large"
          >
            <img :src="img.large" :alt="img.alt" class="img-fluid" />
            <span
              class="zoom"
              @click="
                openModal(
                  product.colorwayGroups.currentColorways[0].images.length +
                    index
                )
              "
              >+</span
            >
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row" v-else-if="!isMobile">
          <!-- =========== show selected color images ============ -->
          <!-- ==================== IF THERE IS A REVERSIBLE TAG ==================== -->
          <div
            v-if="product.tags.includes('reversible')"
            class="col-sm-6 img-slide"
            v-for="(img, index) in selectedColorImages.slice(1)"
            :id="'img1' + index"
            :key="img.large"
          >
            <span v-if="index === 0" class="reversible-tag">Reversible</span>
            <img
              v-if="index === 0"
              :src="selectedColorImages[0].large"
              :alt="selectedColorImages[0].alt"
              itemprop="image"
              class="img-fluid reversible"
            />
            <img :src="img.large" :alt="img.alt" class="img-fluid" />
            <span class="zoom" @click="openModal(index)">+</span>
            <span v-if="index == 0" class="small-print">{{ modelInfo }}</span>
            <div
              v-if="index == 0 && product.videoCta != null"
              class="video-cta"
              @click="openVidmodal()"
            >
              <p v-if="product.videoCta.buttonText != null">
                {{ product.videoCta.buttonText }}
              </p>
              <img
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/Play_Icon.svg"
              />
            </div>
          </div>
          <!-- .col-sm-6 -->
          <!-- ==================== IF THERE IS NOT A REVERSIBLE TAG ==================== -->
          <div
            class="col-sm-6 img-slide"
            v-else
            v-for="(img, index) in selectedColorImages"
            :id="'img1' + index"
            :key="img.large"
          >
            <img
              :src="img.large"
              :alt="img.alt"
              itemprop="image"
              class="img-fluid"
            />
            <span class="zoom" @click="openModal(index)">+</span>
            <span
              v-if="isFirstModelImage(img.alt, index)"
              class="small-print"
              >{{ getModelInfo(img.alt) }}</span
            >
            <span
              v-if="product.tags.includes('deldia') && index == 0"
              class="small-print"
              >*Images are representative, colors will vary</span
            >
            <div
              v-if="index == 0 && product.videoCta != null"
              class="video-cta"
              @click="openVidmodal()"
            >
              <p v-if="product.videoCta.buttonText != null">
                {{ product.videoCta.buttonText }}
              </p>
              <img
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/Play_Icon.svg"
              />
            </div>
          </div>
          <!-- .col-sm-6 -->
          <!-- =========== show product level images =========== -->
          <div
            :class="{
              'col-sm-12': productImages.length === 1 && !selectedColorImages,
              'col-sm-6':
                productImages.length > 1 || selectedColorImages.length >= 1,
            }"
            class="img-slide"
            v-for="(img, index) in productImages"
            :id="'img2' + index"
            :key="img.large"
          >
            <img :src="img.large" :alt="img.alt" class="img-fluid" />
            <span
              class="zoom"
              @click="openModal(selectedColorImages.length + index)"
              >+</span
            >
          </div>
          <!-- .col -->
          <!-- =========== show walk in walk out video =========== -->
          <div
            class="col-sm-6 img-slide video"
            v-if="product.walkInVideo != null"
            :id="vid"
          >
            <video
              playsinline
              loop
              muted
              class="slide-vid"
              width="100%"
              preload="none"
              autoplay
              :poster="product.walkInVideo.thumbnailUrl"
              style="background-color: #fff"
              v-if="!isMobile"
            >
              <source
                :src="product.walkInVideo.videoUrl"
                alt="Walk in, Walk out"
              />
            </video>
            <span
              class="zoom"
              @click="
                openModal(selectedColorImages.length + productImages.length)
              "
              >+</span
            >
          </div>
        </div>
        <!-- .row -->

        <div
          class="ctpx-carousel"
          v-if="
            isMobile && outOfStock && product.colorwayGroups.currentColorways
          "
        >
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="50"
            navigation
            :pagination="{ clickable: true }"
            :zoom="true"
            :lazy="true"
            @swiper="(instance) => setSwiperRef(instance, 'oosMobileRef')"
            @slideChange="onSlideChange"
          >
            <!-- ============ if outofstock show the 1st color images ============ -->
            <swiper-slide
              class="ctpx-slide"
              v-for="(img, index) in product.colorwayGroups.currentColorways[0]
                .images"
              :id="'img1' + index"
              :key="img.large"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="img.large"
                  :alt="img.alt"
                  itemprop="image"
                  class="img-fluid swiper-lazy"
                />
                <span class="small-print">{{ getModelInfo(img.alt) }}</span>
              </div>
            </swiper-slide>
            <!-- =========== show product level images =========== -->
            <swiper-slide
              class="ctpx-slide"
              v-for="(img, index) in productImages"
              :id="'img2' + index"
              :key="img.large"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="img.large"
                  :alt="img.alt"
                  class="img-fluid swiper-lazy"
                  draggable="false"
                />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- ctpx-carousel -->
        <div class="ctpx-carousel" v-else-if="isMobile">
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="50"
            navigation
            :pagination="{ clickable: true }"
            :zoom="true"
            :lazy="true"
            @swiper="(instance) => setSwiperRef(instance, 'mobileRef')"
            @slideChange="onSlideChange"
          >
            <!-- =========== show selected color images ============ -->
            <!-- ==================== IF THERE IS A REVERSIBLE TAG ==================== -->
            <swiper-slide
              v-if="product.tags.includes('reversible')"
              class="ctpx-slide"
              v-for="(img, index) in selectedColorImages.slice(1)"
              :id="'img1' + index"
              :key="img.large"
            >
              <div class="swiper-zoom-container">
                <span v-if="index === 0" class="reversible-tag"
                  >Reversible</span
                >

                <img
                  v-if="index === 0"
                  :src="selectedColorImages[0].large"
                  :alt="selectedColorImages[0].alt"
                  itemprop="image"
                  class="img-fluid reversible"
                  draggable="false"
                />
                <img
                  :src="img.large"
                  :alt="img.alt"
                  itemprop="image"
                  class="img-fluid swiper-lazy"
                  draggable="false"
                />
                <span
                  v-if="product.tags.includes('deldia') && index == 0"
                  class="small-print"
                  >*Images are representative, colors will vary</span
                >
                <span v-else-if="index == 0" class="small-print">{{
                  modelInfo
                }}</span>

                <div
                  v-if="index == 0 && product.videoCta != null"
                  class="video-cta"
                  @click="openVidmodal()"
                >
                  <p v-if="product.videoCta.buttonText != null">
                    {{ product.videoCta.buttonText }}
                  </p>
                  <img
                    src="https://cdn.shopify.com/s/files/1/0281/7544/files/Play_Icon.svg"
                  />
                </div>
              </div>
            </swiper-slide>
            <!-- ==================== IF THERE IS NOT A REVERSIBLE TAG ==================== -->
            <swiper-slide
              v-else
              class="ctpx-slide"
              v-for="(img, index) in selectedColorImages"
              :id="'img1' + index"
              :key="img.large"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="img.large"
                  :alt="img.alt"
                  itemprop="image"
                  class="img-fluid swiper-lazy"
                  draggable="false"
                />
                <span
                  v-if="product.tags.includes('deldia') && index == 0"
                  class="small-print"
                  >*Images are representative, colors will vary</span
                >
                <span class="small-print">{{ getModelInfo(img.alt) }}</span>
                <div
                  v-if="index == 0 && product.videoCta != null"
                  class="video-cta"
                  @click="openVidmodal()"
                >
                  <p v-if="product.videoCta.buttonText != null">
                    {{ product.videoCta.buttonText }}
                  </p>
                  <img
                    src="https://cdn.shopify.com/s/files/1/0281/7544/files/Play_Icon.svg"
                  />
                </div>
              </div>
            </swiper-slide>
            <!-- =========== show product level images =========== -->
            <swiper-slide
              class="ctpx-slide"
              v-for="(img, index) in productImages"
              :id="'img2' + index"
              :key="img.large"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="img.large"
                  :alt="img.alt"
                  class="img-fluid swiper-lazy"
                  draggable="false"
                />
              </div>
            </swiper-slide>
            <!-- =========== show walk in walk out video =========== -->
            <swiper-slide
              class="ctpx-slide"
              v-if="product.walkInVideo != null"
              :id="vid"
            >
              <video
                playsinline
                loop
                muted
                class="slide-vid swiper-lazy"
                width="100%"
                preload="none"
                autoplay
                :poster="product.walkInVideo.thumbnailUrl"
                style="background-color: #fff"
                v-if="isMobile"
              >
                <source
                  :src="product.walkInVideo.videoUrl"
                  alt="Walk in, Walk out"
                />
              </video>
            </swiper-slide>
          </swiper>
        </div>
        <!-- ctpx-carousel -->
      </div>
      <!-- .ctpx-pdp-images -->

      <div class="ctpx-pdp-details ctpx-pdp-details-a">
        <!-- ==================== Detail Box ==================== -->
        <div class="detail-box d-none d-md-block" v-if="!isMobile">
          <div v-if="!isDonationOrGiftCard" class="row">
            <div class="col">
              <!-- ==================== MINI YOTPO STARS ==================== -->
              <div
                @click="scrollToReviews()"
                class="reviews"
                v-if="numReviews > 0"
              >
                <ReviewStars :numStars="avgReview" :numReviews="numReviews" />
              </div>
              <!-- .reviews -->
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
          <div class="row">
            <!-- .col -->
            <div class="col">
              <h1>{{ product.title }}</h1>
              <div v-if="!outOfStock">
                <div v-if="selectedColor.compareAtPrice > selectedVariantPrice">
                  <h4 class="price mb-0">
                    <span class="compare-price">{{
                      formatPrice(selectedColor.compareAtPrice)
                    }}</span>
                    <span class="sale-price">{{
                      formatPrice(selectedVariantPrice)
                    }}</span>
                  </h4>
                  <span class="savings">
                    You save ${{
                      priceSavings(
                        selectedVariantPrice,
                        selectedColor.compareAtPrice
                      )
                    }}
                  </span>
                </div>
                <div v-else>
                  <h4 class="price">
                    {{ formatPrice(selectedVariantPrice) }}
                  </h4>
                </div>
              </div>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
          <div class="row mobile-hidden">
            <div class="col">
              <p class="deets" v-html="whyYoullLoveIt"></p>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- detail-box -->

        <div v-if="!outOfStock">
          <!-- ==================== Variant Color Box ==================== -->
          <div
            v-if="!isDonationOrGiftCard && colorwaysCurrentWithInventory.length"
            class="variant-box colors"
          >
            <div class="row">
              <div class="col">
                <div class="variant-title" v-if="selectedGroup == 0">
                  <span class="bold">Classics: &nbsp;&nbsp;</span> Color |
                  <span class="bold">{{ selectedColor.name }}</span>
                </div>
                <div class="variant-title" v-else>
                  <span class="bold">Classics</span>
                </div>
                <!-- .variant-title -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
            <div class="row variant-options">
              <div
                class="col-auto"
                v-for="(color, index) in colorwaysCurrentWithInventory"
                :key="color.slug"
              >
                <!-- :checked determines the selected swatch on load via the index provided -->
                <div
                  :class="
                    'variant-option variant-option-color ' +
                    color.slug +
                    '-color'
                  "
                >
                  <input
                    type="radio"
                    :id="'radio' + color.slug"
                    name="radioColor"
                    :value="color.name"
                    :checked="
                      index ===
                      colorwaysCurrentWithInventory.findIndex(
                        (c) => c.name == selectedVariant.colorName
                      )
                    "
                  />
                  <label
                    :for="'radio' + color.slug"
                    @click="
                      switchVariant(color, selectedSize);
                      switchGroup(0);
                    "
                    ><span
                      :style="
                        'background-image:url(' +
                        thumbnailify(color.image, '130x') +
                        '); '
                      "
                      >{{ color.name }}</span
                    ></label
                  >
                </div>
                <!-- .variant-option -->
              </div>
              <!-- .col -->

              <div class="col-auto" v-if="product.delDiaVersion">
                <div class="variant-option variant-option-color del-dia">
                  <a
                    :href="product.delDiaVersion.url"
                    class="del-dia-dot"
                    :style="
                      'background-image: url(' +
                      product.delDiaVersion.featuredImage +
                      ');'
                    "
                    >One-of-a-Kind</a
                  >
                </div>
              </div>
            </div>
            <!-- .row variant-options -->
          </div>
          <!-- variant-box -->
          <!-- ==================== CarryOver ==================== -->
          <div
            v-if="
              !isDonationOrGiftCard && colorwaysCarryoverWithInventory.length
            "
            class="variant-box colors"
          >
            <div class="row">
              <div class="col">
                <div class="variant-title" v-if="selectedGroup == 1">
                  <span class="bold">Carryover: &nbsp;&nbsp;</span> Color |
                  <span class="bold">{{ selectedColor.name }}</span>
                </div>
                <div class="variant-title" v-else>
                  <span class="bold">Carryover</span>
                </div>
                <!-- .variant-title -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
            <div class="row variant-options">
              <div
                class="col-auto"
                v-for="(color, index) in colorwaysCarryoverWithInventory"
                :key="color.slug"
              >
                <!-- :checked determines the selected swatch on load via the index provided -->
                <div
                  :class="
                    'variant-option variant-option-color ' +
                    color.slug +
                    '-color'
                  "
                >
                  <input
                    type="radio"
                    :id="'radio' + color.slug"
                    name="radioColor"
                    :value="color.name"
                    :checked="
                      index ===
                      colorwaysCarryoverWithInventory.findIndex(
                        (c) => c.name == selectedVariant.colorName
                      )
                    "
                  />
                  <label
                    :for="'radio' + color.slug"
                    @click="
                      switchVariant(color, selectedSize);
                      switchGroup(1);
                    "
                    ><span
                      :style="
                        'background-image:url(' +
                        thumbnailify(color.image, '130x') +
                        ');'
                      "
                      >{{ color.name }}</span
                    ></label
                  >
                </div>
                <!-- .variant-option -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row variant-options -->
          </div>
          <!-- variant-box -->
          <!-- ==================== SALE ==================== -->
          <div
            v-if="!isDonationOrGiftCard && colorwaysSaleWithInventory.length"
            class="variant-box colors"
          >
            <div class="row">
              <div class="col">
                <div class="variant-title" v-if="selectedGroup == 1">
                  <span class="bold">Sale: &nbsp;&nbsp;</span> Color |
                  <span class="bold">{{ selectedColor.name }}</span>
                </div>
                <div class="variant-title" v-else>
                  <span class="bold">Sale</span>
                </div>
                <!-- .variant-title -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
            <div class="row variant-options">
              <div
                class="col-auto"
                v-for="(color, index) in colorwaysSaleWithInventory"
                :key="color.slug"
              >
                <!-- :checked determines the selected swatch on load via the index provided -->
                <div
                  :class="
                    'variant-option variant-option-color ' +
                    color.slug +
                    '-color'
                  "
                >
                  <input
                    type="radio"
                    :id="'radio' + color.slug"
                    name="radioColor"
                    :value="color.name"
                    :checked="
                      index ===
                      colorwaysSaleWithInventory.findIndex(
                        (c) => c.name == selectedVariant.colorName
                      )
                    "
                  />
                  <label
                    :for="'radio' + color.slug"
                    @click="
                      switchVariant(color, selectedSize);
                      switchGroup(1);
                    "
                    ><span
                      :style="
                        'background-image:url(' +
                        thumbnailify(color.image, '130x') +
                        ');'
                      "
                      >{{ color.name }}</span
                    ></label
                  >
                </div>
                <!-- .variant-option -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row variant-options -->
          </div>
          <!-- variant-box -->
          <!-- ==================== FINAL SALE ==================== -->
          <div
            v-if="
              !isDonationOrGiftCard && colorwaysFinalSaleWithInventory.length
            "
            class="variant-box colors"
          >
            <div class="row">
              <div class="col">
                <div class="variant-title" v-if="selectedGroup == 2">
                  <span class="bold">Final Sale: &nbsp;&nbsp;</span> Color |
                  <span class="bold">{{ selectedColor.name }}</span>
                </div>
                <div v-else class="variant-title">
                  <span class="bold">Final Sale</span>
                </div>
                <!-- .variant-title -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row -->
            <div class="row variant-options">
              <div
                class="col-auto"
                v-for="(color, index) in colorwaysFinalSaleWithInventory"
                :key="color.slug"
              >
                <!-- :checked determines the selected swatch on load via the index provided -->
                <div
                  :class="
                    'variant-option variant-option-color ' +
                    color.slug +
                    '-color'
                  "
                >
                  <input
                    type="radio"
                    :id="'radio' + color.slug"
                    name="radioColor"
                    :value="color.name"
                    :checked="
                      index ===
                      colorwaysFinalSaleWithInventory.findIndex(
                        (c) => c.name == selectedVariant.colorName
                      )
                    "
                  />
                  <label
                    :for="'radio' + color.slug"
                    @click="
                      switchVariant(color, selectedSize);
                      switchGroup(2);
                    "
                    ><span
                      :style="
                        'background-image:url(' +
                        thumbnailify(color.image, '130x') +
                        ');'
                      "
                      >{{ color.name }}</span
                    ></label
                  >
                </div>
                <!-- .variant-option -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row variant-options -->
          </div>
          <!-- variant-box -->
          <!-- ==================== Variant Size Box ==================== -->
          <div
            class="variant-box size"
            v-if="
              !(
                sizeFullName.toLowerCase().includes('bundle') ||
                sizeFullName.toLowerCase().includes('only') ||
                selectedColor.sizes[0].name == 'null' ||
                selectedColor.sizes[0].name.toLowerCase() == 'one size'
              )
            "
          >
            <div class="row">
              <div class="col-auto">
                <div class="variant-title">
                  <span v-if="isDonationOrGiftCard">Value | </span>
                  <span v-else>Size | </span
                  ><span class="bold" v-if="isDonationOrGiftCard">$</span
                  ><span class="bold">{{ sizeFullName }}</span>
                  <span
                    class="message"
                    v-if="
                      selectedSize.available <= 10 &&
                      selectedSize.available >= 1
                    "
                    >Only {{ selectedSize.available }} left in stock!</span
                  ><span
                    class="message"
                    v-else-if="
                      selectedSize.available <= 0 && !selectedSize.isBackOrdered
                    "
                    >Sold Out</span
                  ><span
                    class="message"
                    v-else-if="selectedSize.available > 10"
                  ></span>
                </div>
                <!-- .variant-title -->
              </div>
              <!-- .col -->
              <!-- Button that opens size guide -->
              <button
                v-if="!hideSizeGuide"
                @click="showSizemodal = true"
                class="col text-right size-guide"
              >
                View Size Guide
              </button>
              <!-- .col -->
            </div>
            <!-- .row -->
            <div class="row variant-options">
              <div
                class="col-size"
                v-for="(size, index) in selectedColor.sizes"
                :key="size.name"
              >
                <div class="variant-option variant-option-size">
                  <div
                    class="notify-bell"
                    v-if="
                      !(
                        selectedColor.status === 'Sale' ||
                        selectedColor.status === 'Final Sale'
                      ) &&
                      size.available <= 0 &&
                      !size.isBackOrdered
                    "
                  >
                    <svg
                      version="1.1"
                      id="iconBell"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 16 16"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M86.6,79.2c-4-0.4-7.1-3.5-7.6-7.4l-0.1-25c0-15.6-12.7-28.3-28.3-28.3h-2.1c-15.6,0-28.3,12.7-28.3,28.3l-0.1,25
                          c-0.4,4-3.6,7.1-7.6,7.4c-1.6,0.1-2.9,1.6-2.9,3.2c0,1.7,1.4,3.1,3.1,3.1h24.5C38.9,91,43.8,95,49.7,95c5.8,0,10.8-4,12.2-9.4h24.5
                          c1.7,0,3.1-1.5,3.1-3.2C89.5,80.7,88.2,79.4,86.6,79.2z M59.1,79.3H40.2H24c1.4-2,2.3-4.4,2.6-7.1c0-0.1,0-0.2,0-0.3l0.1-25.1
                          c0-12.1,9.9-22,22-22h2.1c12.1,0,22,9.9,22,22L72.8,72c0,0.1,0,0.2,0,0.3c0.2,2.6,1.1,5,2.6,7.1H59.1z"
                        />
                        <path
                          d="M65.7,7.2c-1.6-0.7-3.4,0.1-4.1,1.7c-0.7,1.6,0.1,3.4,1.7,4.1c13.8,5.6,22.8,18.9,22.8,33.8c0,1.7,1.4,3.1,3.1,3.1
                          s3.1-1.4,3.1-3.1C92.4,29.3,81.9,13.8,65.7,7.2z"
                        />
                        <path
                          d="M13.2,46.8c0-14.9,8.9-28.2,22.8-33.8c1.6-0.7,2.4-2.5,1.7-4.1c-0.7-1.6-2.5-2.4-4.1-1.7C17.4,13.8,7,29.3,7,46.8
                          c0,1.7,1.4,3.1,3.1,3.1S13.2,48.5,13.2,46.8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <!-- .notify-bell -->
                  <input
                    type="radio"
                    :id="'radio' + size.slug"
                    name="radioSize"
                    :value="size.name"
                    :checked="size === selectedSize"
                  />
                  <label
                    :for="'radio' + size.slug"
                    :class="{
                      unavailable: size.available <= 0 && !size.isBackOrdered,
                    }"
                    @click="switchVariant(selectedColor, size)"
                    ><span>{{ size.shortname }}</span></label
                  >
                </div>
                <!-- .variant-option -->
              </div>
              <!-- .col -->
            </div>
            <!-- .row variant-options -->
          </div>
          <!-- variant-box -->
        </div>
        <!-- ==================== Add to Cart Box ==================== -->
        <div
          class="add-to-cart-box sold-out"
          v-if="selectedSize.available <= 0 && !selectedSize.isBackOrdered"
        >
          <div
            v-if="
              selectedVariant.status === 'Final Sale' ||
              selectedVariant.status === 'Sale'
            "
          >
            <!-- if sale -->
            <button class="btn btn-default">Sold Out</button>
          </div>
          <div v-else>
            <!-- is not sale item -->
            <div v-if="!validSubmit">
              <p>
                <small
                  >Unfortunately, this item is sold out. Sign up to get notified
                  if it comes back in stock.</small
                >
              </p>
              <form class="row gx-2" @submit.prevent="notifySubmit">
                <div class="col-6">
                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    v-model="email"
                    id="inputEmail"
                    style="height: 41px"
                    placeholder="Your Email..."
                  />

                  <div v-if="formSubmitted && emailError" class="form-error">
                    <small>{{ emailError }}</small>
                  </div>
                </div>
                <!-- .col -->
                <div class="col-6">
                  <button class="btn btn-black">Notify Me</button>
                </div>
                <!-- .col -->
              </form>
              <!-- .row -->
            </div>
            <div v-else>
              <h2 class="display-4 mb-0">Thank you!</h2>
              <p class="mb-1">
                <small
                  >We will let you know once these are back in stock.</small
                >
              </p>
            </div>
          </div>
          <!-- if not sale -->
        </div>
        <!-- .add-to-cart-box -->
        <div class="add-to-cart-box" v-else>
          <button id="AddToCart" class="btn btn-black" @click="addToCart">
            Add to Cart
            <span class="d-md-none"
              >({{ formatPrice(selectedVariantPrice) }})</span
            >
          </button>
          <!-- final sale disclaimer text -->
          <div
            v-if="selectedVariant.status === 'Final Sale'"
            class="mt-2 text-center"
          >
            <small class="final-sale"
              ><strong>FINAL SALE:</strong> This item cannot be returned or
              exchanged.</small
            >
          </div>
          <!-- ships free over $99 -->
          <div
            v-if="
              selectedVariantPrice > 99.99 &&
              selectedSize.available > 0 &&
              !isDonationOrGiftCard
            "
            class="ships-free"
          >
            <p>
              This Item Ships Free! -
              <span
                ><a
                  target="_blank"
                  href="https://www.cotopaxi.com/pages/shipping-deadlines"
                  >See Details</a
                ></span
              >
            </p>
          </div>

          <klarna-placement
            data-key="credit-promotion-auto-size"
            data-locale="en-US"
            v-bind:data-purchase-amount="selectedVariantPrice * 100"
          ></klarna-placement>

          <!--locally widget-->
          <!-- <div class="accordion-box lcly-accordion">
            <div
              class="accordion-item"
              :class="{ active: locallyOpen === true }"
            >
              <div class="accordion-header" @click="openLocally()">
                <svg
                  width="18"
                  height="24"
                  viewBox="0 0 18 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.67417 21.7385L9.23756 22.3794L9.80087 21.7384C11.0289 20.3409 12.861 18.0933 14.3912 15.7913C15.156 14.6408 15.8554 13.4617 16.3662 12.3581C16.869 11.2719 17.2251 10.1838 17.2251 9.23761C17.225 4.83259 13.6425 1.25 9.23748 1.25C4.83245 1.25 1.25 4.8326 1.25 9.23761C1.25 10.1842 1.60602 11.2726 2.10885 12.3591C2.61965 13.4628 3.31907 14.642 4.08385 15.7924C5.61398 18.0943 7.44608 20.3413 8.67417 21.7385ZM9.23748 5.85733C10.8678 5.85733 12.1953 7.18486 12.1953 8.81516C12.1953 10.4455 10.8678 11.773 9.23748 11.773C7.60718 11.773 6.27965 10.4455 6.27965 8.81516C6.27965 7.18486 7.60718 5.85733 9.23748 5.85733Z"
                    fill="#0398DA"
                    stroke="#26282A"
                    stroke-width="1.5"
                  />
                  <path
                    d="M9.23518 12.5231C11.2797 12.5231 12.943 10.8598 12.943 8.81526C12.943 6.77074 11.2797 5.10742 9.23518 5.10742C7.19066 5.10742 5.52734 6.77074 5.52734 8.81526C5.52734 10.8598 7.19066 12.5231 9.23518 12.5231ZM11.5002 8.81526C11.5002 10.0642 10.4842 11.0803 9.23518 11.0803C7.98619 11.0803 6.97015 10.0642 6.97015 8.81526C6.97015 7.56639 7.98619 6.55023 9.23518 6.55023C10.4842 6.55023 11.5002 7.56639 11.5002 8.81526Z"
                    fill="#26282A"
                  />
                </svg>
                <p>Find in a Cotopaxi store near you</p>
              </div>
              <div class="accordion-content">
                <div class="row">
                  <div class="col locally">
                    <div
                      id="lcly-button-0"
                      data-switchlive="true"
                      data-switchlive-impression="true"
                      data-switchlive-impression-id-PL="1"
                    >
                      <a
                        id="lcly-link-0"
                        data-switchlive="true"
                        data-switchlive-mode="auto"
                        data-switchlive-id-PL="6"
                        role="button"
                        href="https://join.locally.com/for-brands"
                        target="_blank"
                      >
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- .add-to-cart-box -->

        <!-- ========== Section  ========== -->
        <div
          v-if="uptContentWell"
          class="bundler-box"
          :class="{ dark: uptContentWell.textColor === 'dark' }"
          :style="{ backgroundColor: uptContentWell.backgroundColor }"
        >
          <h4>{{ uptContentWell.title }}</h4>
          <p>{{ uptContentWell.subtitle }}</p>
          <a
            v-if="uptContentWell.ctaTitle && uptHandle"
            :href="'/collections/' + uptHandle"
            class="btn btn-black btn-block"
            >{{ uptContentWell.ctaTitle }}</a
          >
          <hr />
          <p>
            <small>{{ uptContentWell.disclaimerText }}</small>
          </p>
        </div>
        <!-- .bundler-box -->

        <!-- ==================== GFG Box ==================== -->
        <a
          href="/pages/guaranteed-for-good"
          alt="Guaranteed for Good™"
          target="_blank"
          class="guaranteed-for-good-box d-flex flex-column align-items-center"
          v-if="!product.tags.includes('Donation')"
        >
          <h3 class="text-center" style="margin-bottom: 20px">
            Guaranteed for Good™
          </h3>
          <div class="row icon-row flex-nowrap mx-2">
            <div class="col-4 flex-column text-center">
              <img
                class="img-icon"
                src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Free-Returns-Exchanges.svg"
                loading="lazy"
                width="30px"
                height="30px"
              />
              <span class="text-center">Easy Returns and Exchanges</span>
            </div>
            <!-- .col-4 -->
            <div class="col-4 flex-column text-center">
              <img
                class="img-icon"
                src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Lifetime-Warranty.svg"
                loading="lazy"
                width="30px"
                height="30px"
              />
              <span class="text-center">Lifetime Warranty + Repairs</span>
            </div>
            <!-- .col-4 -->
            <div class="col-4 flex-column text-center">
              <img
                class="img-icon"
                src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-RePurposed.svg"
                loading="lazy"
                width="30px"
                height="30px"
              />
              <span class="text-center">Trade-In for Gift Cards</span>
            </div>
            <!-- .col-4 -->
          </div>
          <!-- .row --> </a
        ><!-- guaranteed-for-good-box -->
        <!-- ==================== accordion-box ==================== -->
        <div class="accordion-box">
          <div
            class="accordion-item"
            v-for="(accordion, index) in accordionContent"
            :class="{ active: activeDrawer === index }"
            :key="accordion.title"
          >
            <div class="accordion-header" @click="activateAccordion(index)">
              <h4>{{ accordion.title }}</h4>
            </div>
            <!-- accordion-header -->
            <div class="accordion-content">
              <div v-html="accordion.content"></div>
              <!-- <p v-if="index == 0"><strong v-if="modelInfo">Model:</strong> {{modelInfo}}</p> -->
            </div>
            <!-- accordion-content -->
          </div>
          <!-- .accordion-item -->
        </div>
        <!-- .accordion-box -->

        <!-- gift card only chat button -->
        <div class="mt-3" v-if="isGiftCard">
          <h6>Check a Gift Card Balance</h6>
          <button @click="openGiftCardChat()" class="btn btn-black mt-3">
            Chat with Us
          </button>
        </div>
      </div>
      <!-- ctpx-pdp-details -->
      <!-- ==================== Carousel MODAL ==================== -->
      <div class="ctpx-product-modal" v-show="showModal" v-if="!isMobile">
        <div class="ctpx-modal-close" @click="showModal = false">X</div>
        <!-- .ctpx-modal-close -->
        <div
          class="ctpx-modal-content"
          v-if="outOfStock && product.colorwayGroups.currentColorways"
        >
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="50"
            :lazy="true"
            navigation
            @swiper="(instance) => setSwiperRef(instance, 'oosModalRef')"
            @slideChange="onSlideChange"
          >
            <!-- ============ if outofstock show the 1st color images ============ -->
            <swiper-slide
              v-for="(img, index) in product.colorwayGroups.currentColorways[0]
                .images"
              :id="'bigimg1' + index"
              :key="img.xlarge"
            >
              <img
                class="swiper-lazy"
                :src="img.xlarge"
                :alt="img.alt"
                itemprop="image"
              />
            </swiper-slide>
            <!-- =========== show product level images =========== -->
            <swiper-slide
              v-for="(img, index) in productImages"
              :id="'bigimg2' + index"
              :key="img.xlarge"
            >
              <img
                class="swiper-lazy"
                :src="img.xlarge"
                :alt="img.alt"
                itemprop="image"
              />
            </swiper-slide>
          </swiper>
        </div>
        <!-- .ctpx-modal-content -->
        <div class="ctpx-modal-content" v-else>
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="50"
            :lazy="true"
            navigation
            @swiper="(instance) => setSwiperRef(instance, 'modalRef')"
            @slideChange="onSlideChange"
          >
            <!-- =========== show selected color images ============ -->
            <!-- ==================== IF THERE IS A REVERSIBLE TAG ==================== -->
            <swiper-slide
              v-if="product.tags.includes('reversible')"
              v-for="(img, index) in selectedColorImages.slice(1)"
              :id="'bigimg1' + index"
              :key="img.xlarge"
            >
              <img
                v-if="index === 0"
                :src="selectedColorImages[0].xlarge"
                :alt="selectedColorImages[0].alt"
                itemprop="image"
                class="swiper-lazy reversible"
              />
              <img
                class="swiper-lazy"
                :src="img.xlarge"
                :alt="img.alt"
                itemprop="image"
              />
            </swiper-slide>
            <!-- ==================== IF THERE IS NOT A REVERSIBLE TAG ==================== -->
            <swiper-slide
              v-else
              v-for="(img, index) in selectedColorImages"
              :id="'bigimg1' + index"
              :key="img.xlarge"
            >
              <img
                class="swiper-lazy"
                :src="img.xlarge"
                :alt="img.alt"
                itemprop="image"
              />
            </swiper-slide>
            <!-- =========== show product level images =========== -->
            <swiper-slide
              v-for="(img, index) in productImages"
              :id="'bigimg2' + index"
              :key="img.xlarge"
            >
              <img
                class="swiper-lazy"
                :src="img.xlarge"
                :alt="img.alt"
                itemprop="image"
              />
            </swiper-slide>
            <!-- =========== show walk in walk out video =========== -->
            <swiper-slide v-if="product.walkInVideo != null" :id="bigvid">
              <video
                playsinline
                loop
                muted
                class="slide-vid swiper-lazy"
                width="100%"
                preload="none"
                autoplay
                :poster="product.walkInVideo.thumbnailUrl"
                style="background-color: #fff"
                v-if="!isMobile"
              >
                <source
                  :src="product.walkInVideo.videoUrl"
                  alt="Walk in, Walk out"
                />
              </video>
            </swiper-slide>
          </swiper>
        </div>
        <!-- .ctpx-modal-content -->
      </div>
      <!-- ctpx-product-modal -->

      <sizechart
        :productTitle="product.title"
        v-if="showSizemodal"
        @close="showSizemodal = false"
      />
      <div
        class="ctpx-modal-backdrop"
        v-if="showModal"
        @click="showModal = false"
      ></div>
      <!-- .ctpx-modal-backdrop -->

      <!-- ==================== VIDEO CTA MODAL ==================== -->
      <div
        class="ctpx-vid-modal"
        v-if="product.videoCta != null"
        v-show="showVidmodal"
      >
        <div class="ctpx-modal-content">
          <div class="ctpx-modal-close" @click="showVidmodal = false">X</div>
          <!-- .ctpx-modal-close -->
          <h3 v-if="product.videoCta.modalIntroTitle != null" class="vid-title">
            {{ product.videoCta.modalIntroTitle }}
          </h3>
          <p
            v-if="product.videoCta.modalTextArea != null"
            v-html="product.videoCta.modalTextArea"
          ></p>
          <div v-if="product.videoCta.embedCode != null" class="video-wrapper">
            <div v-html="product.videoCta.embedCode"></div>
          </div>
        </div>
        <!-- .ctpx-modal-content -->
      </div>
      <!-- ctpx-product-modal -->
      <div
        class="ctpx-modal-backdrop"
        v-show="showVidmodal"
        @click="showVidmodal = false"
      ></div>
      <!-- .ctpx-modal-backdrop -->

      </div>
    <!-- pdpAba -->
      
      <!-- ==================== LifeStyle Imagery ==================== -->
      <div class="ctpx-pdp-lifestyle-imagery" v-if="product.lifestyleImagery && product.lifestyleImagery.length">
        <div class="container">
          <div class="row d-flex align-items-md-center gx-4">
                <div
                  class="col-md-6 mb-4"
                  :class="index === 0 ? 'col-lg-7' : 'col-lg-5'"
                  v-for="(image, index) in product.lifestyleImagery"
                  :key="image.externalId"
                >
                  <h2 v-if="index === 0" class="display-3">Built For Adventure</h2>
                  <img
                    :src="image.url.replace('upload/', 'upload/f_auto,q_auto/')"
                    class="img-fluid"
                    :alt="image.filename || `Lifestyle Image ${index + 1}`"
                  />
                </div><!-- .col -->
          </div><!-- .row -->
        </div><!-- .container -->
      </div><!-- .ctpx-pdp-lifestyle-imagery --> 

    
  </div>
  </div>

  
</template>

<script src="./ctrl-pdp-standard.js">
import ReviewStars from '../yotpo-reviews/review-stars/review-stars.vue.js';
import PdpErr from './pdp-error/pdp-err.vue';
import sizechart from '../pdp/sizechart/sizechart.vue';
</script>
